import HmEventRegistry from './../model/HmEventRegistry';
import browserStorageUtil from './BrowserStorageUtil';
/**
* This function is responsible for tracking where the user came from.
*/

var AdsTracker = function(){

	var TRACKER_PREFIX = "TRACKER_";
	var trackers = window.webAdsTrackers;

	return{
		getName: function(url){

			if(url && trackers){
				for(var i in trackers){
					if(url.match(i)){
						return trackers[i];
					}
				}
			}

			return null;
		},
		callByUrl: function(url){
			try{
				var args = null;
				if(arguments && arguments.length > 1){
					args = [];
					for(var i =1; i< arguments.length; i++){
						args.push(arguments[i]);
					}
				}

				var name = this.getName(url);
				if(name === null){
					/*if name is null, get the tracker name from session*/
					name = browserStorageUtil.getStoredSessionItem("TRACKER_NAME");
					console.log("important 2: getting the name : ", name);
				}else{
					/*set the tracker name to session*/
					browserStorageUtil.storeSessionItem("TRACKER_NAME", name);
					console.log("important 1: setting the name : ", name);
				}


				if(name){
					var trackName = TRACKER_PREFIX + name.toUpperCase();

					if(HmEventRegistry.exists(trackName)){
						HmEventRegistry.fireEvent(trackName, args);
					}else{
						/*Warn that the tracker is not available or not registered.*/
						console.warn(trackName + " is either not available or registered.");
					}

				}

			}catch(e){
				console.error(e);
			}
		},
		callByReferer: function(trackObj){
			try{
				var refUrl = document.referrer;
	
				//if(refUrl && refUrl.length > 0){
					this.callByUrl(refUrl,trackObj);
				//}
			}catch(e){
				console.error("Error occurred while tracking", e);
			}			
		}
	};

}();

export default AdsTracker;


// WEBPACK FOOTER //
// ./src/util/AdsTracker.js